// extracted by mini-css-extract-plugin
export default {"notification":"notify_notification__83ZiI"};